var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRestore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.006 8.3H5V4h2v3.038L9.47 8.19l-.845 1.813L5 8.313zM10 3a5 5 0 1 1-3-1V0a7 7 0 1 0 4.899 2H13a1 1 0 0 0 0-2H9a.997.997 0 0 0-1 1v4a1 1 0 1 0 2 0z"
})));
export default SvgRestore;